import React from 'react';
import MonitorCard from './MonitorCard';
import Pagination from '@mui/material/Pagination';

interface IMonitorCardsProps {
  cases: any;
  setCases: any;
  handlePageChange: any;
  pageNum: number;
  total: number;
  setSearchVal: any;
  trigger: boolean;
  setTrigger: any;
  setSelectedCase: any;
  setShareModal: any;
  userHasMonitor: boolean;
}

const MonitorCardsDashboard: React.FC<IMonitorCardsProps> = (props: IMonitorCardsProps) => {
  const { cases, handlePageChange, pageNum, total, trigger, setTrigger, setShareModal, setSelectedCase, userHasMonitor } = props;

  return (
    <>
      <div className={`audit-dashboard-cards-frame-box ${!userHasMonitor ? 'os-iframe-blur' : ''}`}>
        {
          cases.length > 0 ? (
            <div className='audit-dashboard-cards-frame'>
              {cases.map((item: any, index: number) => (
                <MonitorCard
                  key={index}
                  ticket={item}
                  trigger={trigger}
                  setTrigger={setTrigger}
                  setSelectedCase={setSelectedCase}
                  setShareModal={setShareModal}
                />
              ))}
            </div>
          ) : (
            <div className='audit-dashboard-cards-no-ticket'>
            No Tickets Found
            </div>
          )
        }
      </div>
      {total > 9 && <div className='hb-pagination'>
        <Pagination
          onChange={handlePageChange}
          size='large'
          count={Math.ceil(total / 9)}
          shape='rounded'
          variant='text'
          page={pageNum}
        />
      </div>
      }
    </>
  );
};

export default MonitorCardsDashboard;
